// src/i18nProvider.js
import polyglotI18nProvider from 'ra-i18n-polyglot';
import englishMessages from 'ra-language-english';

const customEnglishMessages = {
  ...englishMessages,
  ra: {
    ...englishMessages.ra,
    auth: {
      ...englishMessages.ra.auth,
      username: "Email",  // 👈 override label
    },
  },
};

const i18nProvider = polyglotI18nProvider(() => customEnglishMessages, 'en');

export default i18nProvider;
